




































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import WarehousesPlanForm from '../WarehousesPlanForm/WarehousesPlanForm.vue'
import WarehousesMoveForm from '../WarehousesMoveForm/WarehousesMoveForm.vue'

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapGetters(STORE_KEY, [
      'total', 'groupedRows', 'selectedRows'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta', 'days',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WarehousesCarantineList extends Vue {
  public warehouse_id: any = null;
  public dates: any = null;
  public actor!: any;
  public visibleQuantity: boolean = false;
  public selectedRows!: any[];

  mark_value: any = {
    null: {label: 'отлично', color: '#FFFFFF'},
    '1': {label: 'отлично', color: '#00AA00'},
    '2': {label: 'хорошо', color: '#FFFF00'},
    '3': {label: 'повышенное внимание', color: '#FFAA00'},
    '4': {label: 'карантин', color: '#FF0000'},
  }

  get titleStack () {
    return [
      'Склад карантина'
    ]
  }

  openPlanDocument(row: any, fromState: string = 'carantine') {
    const documentPreview: any = {
      id: row.plan_id,
    };
    if (fromState != 'carantine') {
      documentPreview.state = fromState.replace('to-', '');
    }

    this.$buefy.modal.open({
      component: WarehousesPlanForm,
      props: {
        isNew: !row || !row.plan_id,
        fromState:  fromState,
        documentPreview: documentPreview,
        documentId: row.plan_id,
        initParams: {
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }
  
  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

  isRowSelected(row: any): boolean {
    return this.selectedRows.some((selectedRow: any) => selectedRow.plan_id === row.plan_id);
  }

  toggleRowSelection(row: any) {
    if (this.isRowSelected(row)) {
      this.$store.commit(`${STORE_KEY}/REMOVE_SELECTED_ROW`, row);
    } else {
      this.$store.commit(`${STORE_KEY}/ADD_SELECTED_ROW`, row);
    }
  }

  openSelectedRowsDialog() {
    this.$buefy.modal.open({
      component: WarehousesMoveForm,
      props: {
        rows: this.selectedRows
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

}
